import React from "react";
import PropTypes from "prop-types";

import Typography from '@mui/material/Typography';

const Subheader = ({ centered = false, children }) => {
  const sx = {
    color: 'gray',
    ...(centered && { textAlign: 'center' })
  };

  return (
    <Typography
      paragraph
      variant="subtitle2"
      sx={sx}
    >
      {children}
    </Typography>
  )
}

Subheader.propTypes = {
  centered: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default Subheader;
